import { FC, ReactNode } from 'react';

import Button, { ButtonProps } from '@components/buttons/Button';
import IconButton from '@components/buttons/IconButton';
import { LineAwesomeIcon } from '@components/icons/LineAwesomeIcon';

import { PopoverWrapper } from '../Popover/PopoverWrapper';

export type PopoverActionListButton = Omit<ButtonProps, 'children'> & { text: string };

export interface PopoverActionListProps {
  className?: string;
  buttons: PopoverActionListButton[];
  children?: ReactNode;
}

export const PopoverActionList: FC<PopoverActionListProps> = ({ buttons, children, className }) => {
  return (
    <PopoverWrapper
      className={className}
      PopoverContent={({ onClose }) => (
        <div className="d-grid">
          {buttons.map(({ text, onClick, ...buttonProps }, index) => (
            <Button
              key={index}
              className="w-100"
              variant="flat"
              color="neutral"
              {...buttonProps}
              onClick={(event) => {
                onClick?.(event);
                onClose();
              }}
            >
              {text}
            </Button>
          ))}
        </div>
      )}
    >
      {children || (
        <IconButton variant="smooth" color="neutral">
          <LineAwesomeIcon name="ellipsis-h" />
        </IconButton>
      )}
    </PopoverWrapper>
  );
};
